module.exports = __webpack_public_path__ + "fonts/webzuliapack.7e413e31.woff";